define('controllers/modules/questionnaire/questionnaire',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/user',
    // Contollers
    'src/controller/controller',
    // models
    'models/questionnaire/questionnaire',
    'models/questionnaire/response',
    'collections/questionnaire/responses',
    // views
    'views/modules/questionnaire/member/fill-questionnaire-panel'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    User,
    // controller
    Controller,
    // models
    MQuestionnaire,
    MResponse,
    CResponses,
    // views
    VFillQuestionnairePanel
) {

    var QuestionnaireCtrl = Controller.extend({
        authDefault: true,
        routes: {
            '*questionnaire': 'index',
            ':questionnaireId': 'renderQuestionnaire'
        },

        subRoutes: {
            questionnaire: '{{{questionnaireId}}}',
        },

        initialize: function(opt) {
            this.initVars(opt);

            this.listenTo(this.view, 'back', this.onBack);
        },

        initVars: function(opt) {
            opt = opt || {};

            this.model = new MQuestionnaire();
            this.response = new MResponse();
            this.responses = new CResponses();

            _.extend(this, {
                ctrl: {},
                role: opt.role
            });
        },

        index: function() {
            this.getLayout().getContent().toggleInfo(false);
        },

        renderQuestionnaireForm: function() {
            var content = this.getLayout().getContent();
            this.response.setQuestions(this.model.getQuestions());

            this.view = new VFillQuestionnairePanel({
                questionnaire: this.model,
                model: this.response,
                url: this.url.questionnaire,
                role: this.role,
            });

            this.listenTo(this.view, 'back', this.onBack);

            return this.setContent(content);
        },

        setContent: function(content) {
            var self = this;
            return this.when([
                content.toggleInfoOverlay(false)
            ]).then(function() {
                content.setInfoContent(self.view, { open: true });
            });
        },

        renderQuestionnaire: function(groupId, userId, questionnaireId) {
            this.model.setId(questionnaireId);

            this.when(
                User.fetch(),
                this.model.fetch()
            ).then(function() {
                this.responses.reset();
                this.response.reset();
                this.renderQuestionnaireForm();
            });
        },

        onBack: function() {
            Backbone.history.navigate(
                Mustache.render(this.url.root, {
                    userId: this.profile.id,
                    groupId: this.group.id
                }), { trigger: true });
        },

        onLayoutCreation: function(layout) {
            this.profile = layout.getMember();
            this.group = layout.getGroup();
        },

    });

    return QuestionnaireCtrl;
});

